import { Component, OnInit } from '@angular/core';
import {FacebookService, LoginResponse} from "ng2-facebook-sdk";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {AngularFirestore} from "angularfire2/firestore";
import * as firebase from 'firebase';
import {AngularFireAuth} from "angularfire2/auth";

@Component({
  selector: 'login-page',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss']
})
export class LoginPage implements OnInit {

  public user: any;

  constructor(
    private fb: FacebookService,
    private router: Router,
    private translate: TranslateService,
    private db: AngularFirestore,
    public afAuth: AngularFireAuth
  ) {
    this.afAuth.authState.subscribe(authState => {
      this.user = authState;
      if(authState){
        this.enterSite();
      }
    });

  }

  ngOnInit() {
  }

  public login() {
    this.afAuth.auth.signInWithPopup(new firebase.auth.FacebookAuthProvider()).then(res => {
      this.saveUserInfo(res);
    });
  }
  public logout() {
    this.afAuth.auth.signOut();
  }


  public saveUserInfo(response?){
    let user = {
      uid: response.user.uid,
      fbId: response.additionalUserInfo.profile.id,
      email: response.additionalUserInfo.profile.email,
      gender: response.additionalUserInfo.profile.gender,
      name: response.additionalUserInfo.profile.name,
      first_name: response.additionalUserInfo.profile.first_name,
      last_name: response.additionalUserInfo.profile.last_name,
      locale: response.additionalUserInfo.profile.locale,
      picture: response.additionalUserInfo.profile.picture.data.url,
      link: response.additionalUserInfo.profile.link,
    };
    localStorage.setItem('RandomRideUserInfo', JSON.stringify(user));
    this.db.collection('users').doc(user.fbId).set(user);

    this.enterSite();
  }

  public enterSite(){
    this.router.navigate([`/${this.translate.currentLang}`]);
  }


/*


  public openLogInModal(){
   this.fb.login({scope: 'public_profile,email'})
     .then((response: LoginResponse) => {
        console.info('Login successful', response);
        this.updateLoginStatus();
      }).catch((err)=>{
        console.error(err);
      });
  }

  public logOut(){
    this.fb.logout().then((response)=>{
      console.info('Logout successful', response);
    });
  }

  public updateLoginStatus(){
    this.fb.getLoginStatus()
      .then((response) => {
        console.info('Login Status', response);
        if (response.status === 'connected') {localStorage.setItem('RandomRideUserAuth', JSON.stringify(response.authResponse));this.getAccountInfo();
        } else {localStorage.clear();console.log('Auth failed');
        }
      }).catch((err)=>{
        console.error(err);
      });
  }

  public getAccountInfo() {
    this.fb.api('me','get', {fields:'name,picture'})
      .then((response) => {
        console.info('User response', response);
        this.saveUserInfo(response);
      }).catch((err)=>{
        console.error(err);
      });
  }
*/


}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/login-page/login.page.ts